import React from "react";
import {DateTime} from "luxon";
import {useSelector} from "react-redux";
import {RootState} from "redux/store";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import {useTheme} from "@mui/material/styles";

import {GiornoLavorativo} from "components/anagrafiche/anagraficheSlice";

// ============================================
// INTERFACES
// ============================================

interface GanttSettimanaProps {
    giorni: DateTime[];  // 6 giorni (lun-sab)
}

// ============================================
// COMPONENT
// ============================================

const GanttSettimana = ({giorni}: GanttSettimanaProps) => {
    const theme = useTheme();

    const giorniLavorativi = useSelector<RootState, Record<string, GiornoLavorativo>>(
        (state) => state.anagraficheState?.giorniLavorativi?.giorni || {}
    );

    return (
        <Grid container>
            {giorni.map((giorno) => {
                const dataISO = giorno.toISODate() || "";
                const giornoInfo = giorniLavorativi[dataISO];
                const isLavorativo = giornoInfo ? giornoInfo.lavorativo : giorno.weekday < 6;
                const isOggi = giorno.hasSame(DateTime.now(), "day");

                return (
                    <Grid
                        key={dataISO}
                        size={{xs: 2}}
                        sx={{
                            borderRight: `1px solid ${theme.palette.divider}`,
                            backgroundColor: isOggi && !isLavorativo
                                ? theme.palette.secondary.light
                                : isOggi
                                ? theme.palette.primary.light
                                : !isLavorativo
                                    ? theme.palette.grey[200]
                                    : theme.palette.background.paper,
                            p: 0.5,
                            textAlign: "center",
                        }}
                    >
                        <Tooltip
                            title={giornoInfo?.motivo || ""}
                            disableHoverListener={isLavorativo}
                        >
                            <div>
                                <Typography
                                    variant="caption"
                                    fontWeight={isOggi ? "bold" : "normal"}
                                    color={isOggi ? "primary.contrastText" : "text.secondary"}
                                >
                                    {giorno.toFormat("EEE", {locale: "it"})}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    fontWeight={isOggi ? "bold" : "normal"}
                                    color={isOggi ? "primary.contrastText" : "text.primary"}
                                    sx={{
                                        textDecoration: !isLavorativo ? "line-through" : "none",
                                    }}
                                >
                                    {giorno.toFormat("dd")}
                                </Typography>
                            </div>
                        </Tooltip>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default GanttSettimana;